<template>
  <div id="rightBottom">
    <div class="bg-color-black">
      <div class="d-flex title11">
        <span class="fs-xl text_title mx-2 commonTitle">织物使用量排行</span>
      </div>
      <div class="d-flex flex-column body-box padding-xs title22">
        <dv-scroll-ranking-board :config="config" style="width: 100%; height: 100%" />
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "@/api/index";

export default {
  data() {
    return {
      config: {
        waitTime: 10000,
        data: [
          { name: "大包布", value: 0 },
          { name: "枕套", value: 0 },
          { name: "床单", value: 0 },
        ],
      },
      params: {
        customerId: "",
      },
      intervalId: null,
    };
  },
  mounted() {
    this.params.customerId = this.$route.query.customerId;
    this.getData();

    this.intervalId = setInterval(() => {
      this.getData();
    }, 60 * 60 * 1000);
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    async getData() {
      this.params.statusApprove = 0;
      const res = await api.getBigSkuWashSpu(this.params);
      if (res.ResultCode === 0) {
        this.config.data = (res.Result || [])
          .sort((a, b) => b.num - a.num)
          .map((v) => ({
            name: v.spuName,
            value: v.num,
          }));
        this.config = { ...this.config };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#rightBottom {
  ::v-deep .ranking-column {
    border: none;
  }

  padding: 0 16px;
  height: 100%;
  width: 100%;
  border-radius: 5px;

  .bg-color-black {
    border-radius: 10px;
    height: 100%;
    .title11 {
      height: 18%;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    }
    .title22 {
      height: 82%;
    }
  }

  .body-box {
    border-radius: 10px;
    overflow: hidden;
  }
}
</style>

